var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.0962,
    cy: 6.93214,
    r: 6.13527,
    fill: "#008069"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.0962,
    cy: 6.93214,
    r: 6.13527,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55259 7.01165L4.55263 7.01155C4.68587 6.681 4.88123 6.38702 5.13517 6.13307C5.38917 5.88104 5.68507 5.68386 6.01364 5.5505C6.06305 5.53107 6.11246 5.51284 6.16186 5.49581V6.06571C5.92503 6.16816 5.70465 6.3152 5.51101 6.50883C5.11 6.90986 4.88978 7.44168 4.88978 8.00872C4.88978 8.57577 5.10998 9.10758 5.51101 9.50861C5.90798 9.90557 6.43311 10.1254 6.9937 10.1298L6.99376 10.1299H7.01094C7.56976 10.1299 8.09424 9.9161 8.49677 9.52995L8.87267 9.90585C8.62266 10.1495 8.33288 10.3407 8.01193 10.4709C7.69404 10.5988 7.35811 10.6646 7.01285 10.6646C6.66747 10.6646 6.33144 10.6006 6.01381 10.4709L6.01371 10.4709C5.68318 10.3377 5.38921 10.1423 5.13527 9.8884C4.8832 9.63437 4.68599 9.33843 4.55263 9.00981C4.42471 8.69191 4.35898 8.35596 4.35898 8.01068C4.35898 7.66531 4.42294 7.32928 4.55259 7.01165Z",
    fill: "white",
    stroke: "#008069",
    strokeWidth: 0.049982
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2392 9.24324L10.2459 9.24997C10.4119 9.42128 10.4103 9.69404 10.2392 9.86507C10.0681 10.0362 9.78844 10.0362 9.61734 9.86507L9.61724 9.86497L8.33795 8.5894L8.30869 8.56022H8.26737H6.4698C6.2264 8.56022 6.02965 8.36348 6.02965 8.12008V5.12605C6.02965 4.88265 6.2264 4.6859 6.4698 4.6859C6.71319 4.6859 6.90994 4.88265 6.90994 5.12605V5.38414V5.48411H7.0099H8.60093C8.79456 5.48411 8.95261 5.64215 8.95261 5.83579C8.95261 6.02943 8.79456 6.18747 8.60093 6.18747H7.0099H6.90994V6.28744V7.57792V7.67789H7.0099H8.44969V7.67845L8.46028 7.67732C8.48521 7.67467 8.51239 7.67574 8.54415 7.67912L8.54415 7.67914L8.54568 7.67928C8.677 7.69124 8.79291 7.76299 8.86544 7.86726L8.87052 7.87457L8.87682 7.88086L10.2392 9.24324Z",
    fill: "white",
    stroke: "#008069",
    strokeWidth: 0.199928
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23263 3.80985C7.23263 4.23315 6.8894 4.57638 6.4661 4.57638C6.0428 4.57638 5.69957 4.23315 5.69957 3.80985C5.69957 3.38655 6.0428 3.04332 6.4661 3.04332C6.8894 3.04332 7.23263 3.38655 7.23263 3.80985Z",
    fill: "white",
    stroke: "#008069",
    strokeWidth: 0.199928
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairAccess);
export default __webpack_public_path__ + "static/media/wheelchair_access.0dea6bdd0b043af7bd6e0ce8cc9ab293.svg";
export { ForwardRef as ReactComponent };